import React from 'react';
import { SunriseIcon, SunIcon, MoonIcon } from './TimeSlotIcons';

interface AvailabilityLegendProps {
  className?: string;
}

export const AvailabilityLegend: React.FC<AvailabilityLegendProps> = ({ className = '' }) => {
  const itemClass = 'flex items-center gap-2 px-2.5 py-1 bg-gray-50 rounded-md border border-gray-200';
  const labelClass = 'text-[11px] text-gray-700 leading-none';
  const timeClass = 'text-[10px] text-gray-500 leading-none';

  return (
    <div className={`flex flex-wrap items-center justify-center gap-2 ${className}`}>
      <div className={itemClass}>
        <SunriseIcon size={16} />
        <div className="flex flex-col leading-tight">
          <span className={labelClass}>Matin</span>
          <span className={timeClass}>09:00 – 12:00</span>
        </div>
      </div>
      <div className={itemClass}>
        <SunIcon size={16} />
        <div className="flex flex-col leading-tight">
          <span className={labelClass}>Après-midi</span>
          <span className={timeClass}>12:00 – 17:00</span>
        </div>
      </div>
      <div className={itemClass}>
        <MoonIcon size={16} />
        <div className="flex flex-col leading-tight">
          <span className={labelClass}>Soir</span>
          <span className={timeClass}>17:00 – 21:00</span>
        </div>
      </div>
    </div>
  );
};

export default AvailabilityLegend;


